"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typography = exports.getFontImportsURL = void 0;
var spacing_1 = require("./spacing");
var colors_1 = require("./colors");
var base_1 = require("../utils/base");
// font
var font = {
    size: base_1.pxToRem(16),
    weight: {
        regular: 400,
        bold: 700,
    },
    family: {
        sansSerif: "Lato,'Lucida Grande',Tahoma,'Helvetica Neue',Helvetica,-apple-system,BlinkMacSystemFont,'Segoe UI','PingFang SC','Hiragino Sans GB','Microsoft YaHei',Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'",
        serif: "Volkhov,Georgia,Times,Serif",
        headline: "Lato,'Helvetica Neue',Helvetica,-apple-system,BlinkMacSystemFont,'Segoe UI','PingFang SC','Hiragino Sans GB','Microsoft YaHei',Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'",
        code: "'Roboto Mono',SFMono-Regular,Consolas,'Liberation Mono',Menlo,Courier,monospace",
    },
    lineHeight: {
        default: 1.375,
    },
};
// headlines
var h1 = {
    fontSize: base_1.pxToRem(46),
    margin: '46px 0 13px',
    padding: '0',
};
var h2 = {
    fontSize: base_1.pxToRem(36),
    margin: '42px 0 16px',
    padding: '0',
};
var h3 = {
    fontSize: base_1.pxToRem(30),
    margin: '40px 0 17px',
    padding: '0',
};
var h4 = {
    fontSize: base_1.pxToRem(24),
    margin: '38px 0 20px',
    padding: '0',
};
var h5 = {
    fontSize: base_1.pxToRem(18),
    margin: '36px 0 22px',
    padding: '0',
};
var h6 = {
    fontSize: base_1.pxToRem(13),
    margin: '34px 0 24px',
    padding: '0',
};
// textStyles
var jumbo = {
    fontSize: base_1.pxToRem(24),
};
var big = {
    fontSize: base_1.pxToRem(18),
};
var normal = {
    fontSize: base_1.pxToRem(16),
};
var small = {
    fontSize: base_1.pxToRem(14),
};
var micro = {
    fontSize: base_1.pxToRem(13),
};
var notification = {
    fontSize: base_1.pxToRem(14),
};
// attribution
var quote = {
    fontSize: base_1.pxToRem(30),
};
var author = {
    fontSize: base_1.pxToRem(18),
};
// code
var code = {
    fontSize: base_1.pxToRem(13),
    contrastBackgroundColor: colors_1.color.N10,
    contrastColor: colors_1.color.N5,
    padding: spacing_1.spacing.lg,
};
function getFontImportsURL() {
    var sansSerifFont = font.family.sansSerif.split(',')[0] + ":" + [
        font.weight.regular,
        font.weight.bold,
    ].join(',');
    var serifFont = font.family.serif.split(',')[0] + ":" + [
        font.weight.regular,
        font.weight.bold,
    ].join(',');
    var codeFont = font.family.code.split(',')[0] + ":" + [
        font.weight.regular,
        font.weight.bold,
    ].join(',');
    return "https://fonts.googleapis.com/css?family=" + [sansSerifFont, serifFont, codeFont].join('|');
}
exports.getFontImportsURL = getFontImportsURL;
exports.typography = {
    font: font,
    h1: h1,
    h2: h2,
    h3: h3,
    h4: h4,
    h5: h5,
    h6: h6,
    textStyles: {
        jumbo: jumbo,
        big: big,
        normal: normal,
        small: small,
        micro: micro,
        notification: notification,
        quote: quote,
        author: author,
        code: code,
    },
};
//# sourceMappingURL=typography.js.map